import React from 'react';
import { CategoriesLinksComponent } from 'swag-client-common/components/partials/categories-links';
import { LogoCategoriesPrerender } from './logo-categories-prerender';
import classes from './product-listing-panel.scss';
export function ProductListingPanelComponent({
  categories,
  currentMainCategory,
  currentSubcategoryId,
  isActiveFilterBlockShown,
  isViolet,
  currentRoute,
  onLinkClick,
  isFilterOpened,
  allSubcategories,
  shouldNotShowCategories
}) {
  if (shouldNotShowCategories) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement(CategoriesLinksComponent, {
    categories: categories,
    isViolet: isViolet,
    currentRoute: currentRoute,
    onLinkClick: onLinkClick,
    isShadowDisabled: !!isActiveFilterBlockShown,
    currentSubcategoryId: currentSubcategoryId,
    currentMainCategory: currentMainCategory,
    isFilterOpened: isFilterOpened,
    allSubcategories: allSubcategories
  }), /*#__PURE__*/React.createElement(LogoCategoriesPrerender, null));
}